module.exports = __webpack_public_path__ + "static/media/distanziert.1d6cc75d.svg";